// Copyright TraderEvolution Global LTD. © 2017-2023. All rights reserved.

import { TerceraMainHeaderButtonTemplate } from "../../templates.js";
import { TerceraButton } from "./TerceraButton.js";

export let TerceraMainHeaderButton = TerceraButton.extend({
    template: TerceraMainHeaderButtonTemplate,
    data: function ()
    {
        return {
            text: '',
            haveBackground: false
        };
    },
});

TerceraMainHeaderButton.prototype.getType = function () { return 'TerceraMainHeaderButton' };